import {Component, forwardRef, Input,OnInit,OnChanges, SimpleChanges} from '@angular/core';
import { NG_VALUE_ACCESSOR, Validators, FormGroup, FormControl, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {AbstractControlValueAccessor} from '../abstract-control-value-accessor';
import {distinctUntilChanged, tap} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {UntilDestroy} from '@ngneat/until-destroy';
import {setupUntilDestroy} from '@portal-workspace/grow-ui-library';
import {MARK, Mark} from '@portal-workspace/grow-ui-library/mark';
import {compareMatch, LoanTermValue, LoanTermValueOptions} from '@portal-workspace/grow-shared-library';
import { MatOptionModule } from '@angular/material/core';

import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DisableControlDirective } from '../../directives/disable-control.directive';



@UntilDestroy()
@Component({
    selector: 'loan-terms-selection',
    templateUrl: './loan-terms-selection.component.html',
    styleUrls: ['./loan-terms-selection.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => LoanTermsSelectionComponent), multi: true },
        { provide: MARK, useExisting: forwardRef(() => LoanTermsSelectionComponent) },
    ],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatOptionModule, DisableControlDirective]
})
export class LoanTermsSelectionComponent extends AbstractControlValueAccessor<LoanTermValue> implements OnInit, OnChanges, Mark{

  @Input({required: false}) maxTerm: number | null = null;

  compareWithFn: (option: LoanTermValue, selected: LoanTermValue) => boolean = (option, selected) => {
    return (!!option && !!selected && option.type === selected.type);
  };


  formGroup: FormGroup<{
    selection:FormControl<LoanTermValue>;
  }>;
  formControl: FormControl<LoanTermValue>;
  subscription: Subscription;

  options = LoanTermValueOptions;
  filteredOptions = LoanTermValueOptions;

  constructor(private formBuilder: FormBuilder) {
    super();
    this.formControl = formBuilder.control(null, [Validators.required]);
    this.formGroup = formBuilder.group({
      selection: this.formControl
    });
    this.subscription = this.formControl.valueChanges.pipe(
      distinctUntilChanged(compareMatch),
      tap((r: LoanTermValue) => {
        this.propagateChange(r);
      })
    ).subscribe();
  }

  ngOnInit(): void {
    setupUntilDestroy(this);
    this.updateFilteredOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes as any).maxTerm) {
      this.updateFilteredOptions();
    }
  }

  private updateFilteredOptions(): void {
    if (this.maxTerm != null) {
      this.filteredOptions = this.options.filter(o => parseInt(o.type) <= this.maxTerm!);
      const currentValue = this.formControl.value;
      if (currentValue && parseInt(currentValue.type) > this.maxTerm) {
        this.formControl.setValue(null);
        this.propagateChange(null);
      }
    } else {
      this.filteredOptions = this.options;
    }
  }

  doWriteValue(v: LoanTermValue): void | LoanTermValue {
    if (v) {
      const op = this.filteredOptions.find(o => o.type === v.type);
      if (op) {
        this.formControl.setValue(op);
        return op;
      }
      this.formControl.setValue(null);
      this.propagateChange(null);
    }
    return undefined;
  }
  mark() {
    this.formGroup.markAllAsTouched();
  }

  reset(): void {
    this.formControl.reset();
  }
}
